module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-8.c0a76359.png";